/** import local dependencies */
import AddEntry from './components/gp-nestedforms-add-entry';

/** Initialise local dependencies */
window.addEventListener('DOMContentLoaded', () => AddEntry.init());
